(() => {
  class StickyAddToCart {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.productFormId = container.dataset.productFormId;
      this.stickyButton = container.querySelector('[data-sticky-atc-button]');
      this.stickyLabel = container.querySelector('[data-sticky-atc-label]');
      this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.productForm = document.getElementById(this.productFormId);

      if (!this.stickyButton || !this.sourceButton || !this.productForm) {
        this.container.remove();
        return;
      }

      this.stickyButton.addEventListener('click', this.onStickyClick.bind(this));

      this.observeSourceButton();
      this.observeSourceButtonVisibility();
      this.syncButtonState();
      this.syncVisibility();
    }

    onStickyClick(event) {
      event.preventDefault();

      if (this.stickyButton.disabled || this.stickyButton.getAttribute('aria-disabled') === 'true') return;

      if (typeof this.productForm.requestSubmit === 'function') {
        this.productForm.requestSubmit();
        return;
      }

      this.productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    observeSourceButton() {
      this.sourceButtonObserver = new MutationObserver(() => this.syncButtonState());
      this.sourceButtonObserver.observe(this.sourceButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    observeSourceButtonVisibility() {
      if ('IntersectionObserver' in window) {
        const visibilityTarget = this.sourceButton.closest('.product-form__buttons') || this.sourceButton;

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const [entry] = entries;
            this.sourceButtonIsIntersecting = entry.isIntersecting;
            this.syncVisibility();
          },
          { threshold: 0.01 }
        );

        this.visibilityObserver.observe(visibilityTarget);
      }

      this.onViewportChange = this.syncVisibility.bind(this);
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);
    }

    isSourceButtonVisible() {
      if (!this.sourceButton || this.sourceButton.offsetParent === null) return false;

      const style = window.getComputedStyle(this.sourceButton);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

      if (typeof this.sourceButtonIsIntersecting === 'boolean') return this.sourceButtonIsIntersecting;

      const rect = this.sourceButton.getBoundingClientRect();
      return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    }

    syncVisibility() {
      const shouldShowSticky = !this.isSourceButtonVisible();
      this.container.classList.toggle('is-visible', shouldShowSticky);
      this.container.setAttribute('aria-hidden', shouldShowSticky ? 'false' : 'true');
    }

    syncButtonState() {
      const isDisabled =
        this.sourceButton.hasAttribute('disabled') || this.sourceButton.getAttribute('aria-disabled') === 'true';
      const isLoading = this.sourceButton.classList.contains('loading');
      const sourceLabelElement = this.sourceButton.querySelector('span');
      const sourceLabelHtml = sourceLabelElement ? sourceLabelElement.innerHTML : '';
      const sourceDisabledLabel = this.sourceButton.querySelector('.sold-out-message:not(.hidden)')?.textContent?.trim();

      this.stickyButton.toggleAttribute('disabled', isDisabled);
      this.stickyButton.classList.toggle('loading', isLoading);

      const spinner = this.stickyButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !isLoading);

      if (this.stickyLabel) {
        if (sourceDisabledLabel) {
          this.stickyLabel.textContent = sourceDisabledLabel;
        } else if (sourceLabelHtml) {
          this.stickyLabel.innerHTML = sourceLabelHtml;
        }
      }
    }
  }

  const initStickyAddToCart = (root = document) => {
    root.querySelectorAll('[data-sticky-atc]').forEach((container) => {
      if (container.dataset.stickyAtcInitialized === 'true') return;
      container.dataset.stickyAtcInitialized = 'true';
      new StickyAddToCart(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyAddToCart(document));
  } else {
    initStickyAddToCart(document);
  }

  document.addEventListener('product-info:loaded', (event) => initStickyAddToCart(event.target));
  document.addEventListener('shopify:section:load', (event) => initStickyAddToCart(event.target));
})();
